import { Typography } from "@/components";
import AddIcon from "@mui/icons-material/Add";
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import InboxTwoToneIcon from "@mui/icons-material/InboxTwoTone";
import Button from "@mui/material/Button";
import type React from "react";

interface EmptyInboxProps {
	variant?: "inbox" | "reminder";
	title?: string;
	addLabel?: string;
	onClickAdd?: React.MouseEventHandler<HTMLButtonElement>;
}

function EmptyInbox(props: EmptyInboxProps) {
	const { variant = "inbox", title = "No inbox", addLabel, onClickAdd } = props;
	return (
		<div className="h-full flex flex-col justify-center items-center gap-3">
			<div className="bg-white p-5 rounded-[3rem]">
				{variant === "inbox" ? (
					<InboxTwoToneIcon className="!text-[5rem] !text-zinc-500" />
				) : (
					<ChecklistRoundedIcon className="!text-[5rem] !text-zinc-500" />
				)}
			</div>
			<Typography fontWeight={700} fontSize={16}>
				{title}
			</Typography>
			{onClickAdd && addLabel ? (
				<Button
					variant="contained"
					color="primary"
					className="!h-12 !rounded-full"
					onClick={onClickAdd}
					startIcon={<AddIcon />}
				>
					{addLabel}
				</Button>
			) : null}
		</div>
	);
}

export default EmptyInbox;
